import css from "./CataloguePage.module.scss";
import React, { useState } from "react";
import { Catalogue } from "components/Catalogue/Catalogue";
import { MySorting } from "components/UI/sorting/MySorting";
import {
  cartItems,
  catalogueItem,
  filteringData,
  itemControllerInfo,
  sortMethod,
} from "assets/types";
import { FieldFilter } from "components/UI/fieldFilter/FieldFilter";
import { Filters } from "components/Filters/Filters";
import { useSorting } from "hooks/useSorting";
import { useFiltering } from "hooks/useFiltering";
import { MyButton } from "components/UI/button/MyButton";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { RootState } from "store/store";

export const CataloguePage = ({
  cartItems,
  getCartItems,
  getItemControllerInfo,
}: {
  cartItems: cartItems;
  getCartItems: (result: cartItems) => void;
  getItemControllerInfo: (result: itemControllerInfo) => void;
}) => {
  const catalogueItems = useSelector((state: RootState) => state.catalogue);
  const mobile = useSelector((state: RootState) => state.mobile);

  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState<Array<filteringData>>([]);
  const [sortingInfo, setSortingInfo] = useState<sortMethod>({
    slug: "brand",
    direction: "asc",
  });

  return (
    <main data-testid="cataloguePage" className={css.page}>
      <div className={css.page__top}>
        <div className={css.page__wrapper}>
          <div>
            <h1 className={css.page__title}>Косметика и гигиена</h1>
            <MyButton
              testID="newCatalogueItem"
              icon={<Icon icon="material-symbols:add" width="24" />}
              width="39px"
              height="39px"
              click={() => {
                getItemControllerInfo({ active: true });
              }}
            />
          </div>
          <MySorting
            sortOptions={[
              { slug: "brand", text: "Название", direction: "asc" },
              { slug: "brand", text: "Название", direction: "desc" },
              { slug: "price", text: "Цена", direction: "asc" },
              { slug: "price", text: "Цена", direction: "desc" },
            ]}
            callback={(result: sortMethod) => {
              setSortingInfo(result);
            }}
          />
        </div>
        <FieldFilter
          isVertical={mobile}
          filtersData={filters}
          filters={[
            { slug: "treatment", value: "body", text: "Уход за телом" },
            { slug: "treatment", value: "hands", text: "Уход за руками" },
            { slug: "treatment", value: "legs", text: "Уход за ногами" },
            { slug: "treatment", value: "face", text: "Уход за лицом" },
            { slug: "treatment", value: "hair", text: "Уход за волосами" },
          ]}
          changeFiltersData={(result: Array<filteringData>) => {
            setPage(0);
            setFilters(result);
          }}
        />
      </div>
      <div className={css.page__bottom}>
        <div className={css.page__left}>
          <Filters
            filtersData={filters}
            chandgeFiltersData={(result: Array<filteringData>) => {
              setPage(0);
              setFilters(result);
            }}
          />
          {!mobile && <FieldFilter
            isVertical={true}
            filtersData={filters}
            filters={[
              { slug: "treatment", value: "body", text: "Уход за телом" },
              { slug: "treatment", value: "hands", text: "Уход за руками" },
              { slug: "treatment", value: "legs", text: "Уход за ногами" },
              { slug: "treatment", value: "face", text: "Уход за лицом" },
              {
                slug: "treatment",
                value: "hair",
                text: "Уход за волосами",
              },
            ]}
            changeFiltersData={(result: Array<filteringData>) => {
              setFilters(result);
            }}
          />}
        </div>
        <div className={css.page__right}>
          <Catalogue
            page={page}
            changePage={(page: number) => setPage(page)}
            list={useSorting({
              list: useFiltering({
                list: catalogueItems,
                filters: filters,
              }),
              ...sortingInfo,
            })}
            limit={15}
            cartItems={cartItems}
            getCartItems={(result: cartItems) => {
              getCartItems(result);
            }}
            controllerCallback={(result: catalogueItem) => {
              getItemControllerInfo({ data: result, active: true });
            }}
          />
          <article>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
              interdum ut justo, vestibulum sagittis iaculis iaculis. Quis
              mattis vulputate feugiat massa vestibulum duis. Faucibus
              consectetur aliquet sed pellentesque consequat consectetur congue
              mauris venenatis. Nunc elit, dignissim sed nulla ullamcorper enim,
              malesuada.
            </p>
          </article>
        </div>
      </div>
    </main>
  );
};
